/* ══════════════ Warum man woanders gelandet ist (D-03, 03.10.2026) ══════════════

   Kalle tippte `/abrechnung`, `/auftraege`, `/planung` ab und stand jedes
   Mal ohne ein Wort auf „Heute". Sicher war das — kein Preis, keine fremde
   Akte —, aber stumm: Wer einen Link aus einer Mail öffnet, hält das für
   einen Fehler und versucht es noch einmal.

   Der Wächter im Routenbaum hat keinen React-Kontext und kann nicht rufen.
   Er legt den Grund deshalb hier ab, und die Schale nimmt ihn beim nächsten
   Bild und sagt einen Satz. Genau einmal: `nehmen` leert den Platz.

   **Still bleiben die Wege, die nur Einstieg heißen** — `/`, `/start`,
   `/heute`. Wer dort umgeleitet wird, ist genau da, wo er hinwollte. */

export type Umleitungsgrund = "recht" | "telefon";

export type Umleitung = { von: string; grund: Umleitungsgrund };

const STILL = new Set(["/", "/start", "/heute"]);

let offen: Umleitung | null = null;

/** Der Wächter merkt sich, von wo er weggeschickt hat und warum. */
export function umleitungMerken(von: string, grund: Umleitungsgrund): void {
  if (STILL.has(von)) return;
  offen = { von, grund };
}

/** Einmal abholen — danach ist der Platz leer. */
export function umleitungNehmen(): Umleitung | null {
  const u = offen;
  offen = null;
  return u;
}

/** Der Satz dazu, als Schlüssel unter `meldung.*`. */
export function umleitungsSatz(u: Umleitung): string {
  if (u.grund === "telefon" && (u.von.startsWith("/planung") || u.von.startsWith("/kalender"))) return "umleitungPlanung";
  return u.grund === "recht" ? "umleitungRecht" : "umleitungTelefon";
}
